export const name = 'headerActions';
export const RECEIVED_HEADER_STATE = `${name}_RECEIVED_HEADER_STATE`;

export function setHeaderModal(isModalOpen) {
  return function (dispatch, state) {
    dispatch({
      type: RECEIVED_HEADER_STATE,
      isModalOpen: isModalOpen,
    });
  };
}
